'use client';

import { useEffect, useState } from 'react';

const useMediaQuery = (query: string, initialState = false) => {
  const [matches, setMatches] = useState(initialState);

  useEffect(() => {
    if (typeof window !== 'undefined' && window) {
      const media = window.matchMedia(query);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setMatches(media.matches);
    }
  }, [query]);

  useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    window.addEventListener('resize', listener);
    return () => window.removeEventListener('resize', listener);
  }, [query]);

  return matches;
};

export default useMediaQuery;
